import { Button, Card, CardBody, CardHeader, Label } from "reactstrap";
import { useNavigate } from "react-router-dom";
import logo from "@workspace/main/public/AvensysLogo.png";

const StartAssessment = () => {
  const navigate = useNavigate();

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ marginTop: "10%", marginBottom: "10%" }}
    >
      <h3>Sub: Job ID | Assessment Name | Date</h3>
      <Card style={{ width: "65%", margin: "auto", maxWidth: "500px" }}>
        <CardHeader
          style={{
            backgroundColor: "#0B56AE",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={logo} style={{ height: "120px", width: "auto" }} />
        </CardHeader>
        <CardBody>
          <Label>Dear $NAME</Label>
          <p>
            <span>
              As part of our hiring process, we kindly request you to complete
              the following assessment to help us evaluate your skills and
              suitability for the role. Please find the details below:
            </span>
          </p>
          <span>Deadline: $DEADLINE</span>
          <br />
          <br />
          <span>Assessment Link: $ASSESSMENTLINK</span>
          <br />
          <br />
          <Button
            className="take-assessment"
            style={{ backgroundColor: "#0B56AE", color: "white" }}
            onClick={() => {
              navigate("/assessment-taking");
            }}
          >
            Take Assessments
          </Button>
          <br />
          <br />
          <span>Or copy-paste it in your browser</span>
          <br />
          <a href="" style={{ color: "#0B56AE" }}>
            ASSESSMENT LINK
          </a>
          <br />
          <br />
          <span>
            If you face any issues accessing the assessment or have any
            questions, feel free to reach out to me.
          </span>
          <br />
          <br />
          <span>
            We look forward to your timely completion of the assessment.
          </span>
          <br />
          <br />
          <span>Best Regards,</span>
          <div style={{ height: "75px" }} />
        </CardBody>
      </Card>
    </div>
  );
};

export default StartAssessment;
